const doc = document
const elements = {
  title: doc.querySelector('.product__title h1'),
  image: doc.querySelector(window.custom_template !== 'foam' ? '#ProductPhotoImg-product-template' : '#customProductPreviewImage'),
  form: doc.querySelector('#AddToCartForm'),
  addButton: doc.querySelector('#AddToCart-product-template'),
  types: [...doc.querySelectorAll('.Type-labels')],
  layouts: [...doc.querySelectorAll('.Layout-labels')],
  sizes: [...doc.querySelectorAll('.Size-labels')],
  depths: [...doc.querySelectorAll('.Depth-labels')],
  amounts: [...doc.querySelectorAll('.Amount-labels')],
  colors: [...doc.querySelectorAll('.Color-labels')]
}

export default elements
